import { memo } from 'react';
import { Box, Button, Modal, SpaceBetween } from '@amzn/awsui-components-core';

import {
  DuplicateScanResultsView,
  DuplicateScanResultItem,
} from '../duplicate-scan-results/DuplicateScanResultsView';

interface DuplicationResultsModalProps {
  readonly matches: readonly DuplicateScanResultItem[];
  readonly onDismiss: () => void;
  /** Called when the reviewer clicks through to a matched article. */
  readonly onResultClick?: (matchedContentId: string) => void;
}

/** Modal listing the top duplication matches (>=60% similarity) for a bar raiser to review. */
export const DuplicationResultsModal = memo(function DuplicationResultsModal({
  matches,
  onDismiss,
  onResultClick,
}: DuplicationResultsModalProps) {
  return (
    <Modal
      visible
      header="Duplication results"
      onDismiss={onDismiss}
      closeAriaLabel="Close modal"
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button variant="primary" onClick={onDismiss}>
              Close
            </Button>
          </SpaceBetween>
        </Box>
      }
    >
      <DuplicateScanResultsView results={matches} onResultClick={onResultClick} />
    </Modal>
  );
});
